import { PaginationInstance } from 'ngx-pagination';
import { Profile } from '../configurations/profile.constant';

export class PaginationUtils {
    public static calcPagesCount(paginationConfig: PaginationInstance, bulkSize = Profile.BULK_SIZE) {
        return Math.ceil(paginationConfig.totalItems / bulkSize);
    }

    public static searchOffset(paginationConfig: PaginationInstance, bulkSize = Profile.BULK_SIZE) {
        return (paginationConfig.currentPage - 1) * bulkSize;
    }

    public static getNumOfCopies(paginationConfig: PaginationInstance, bulkSize = Profile.BULK_SIZE) {
        const totalItems = paginationConfig.totalItems ?? Number.MAX_SAFE_INTEGER;
        return Math.min(
            bulkSize,
            totalItems -
                (paginationConfig.currentPage - 1) * bulkSize
        );
    }
}
